import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './styles.css';

export default function ProfileChips({ active }) {
  const { t } = useTranslation();
  return (
    <div className="feed-chips profile-chips">
      <Link className={active === 'profile' ? 'is-active' : ''} to="/perfil">
        {t('pages.includes.navProfile.profile')}
      </Link>
      <Link className={active === 'publications' ? 'is-active' : ''} to="/publicacoes">
        {t('pages.includes.navProfile.publications')}
      </Link>
      <Link className={active === 'ads' ? 'is-active' : ''} to="/meus-anuncios">
        {t('pages.includes.navProfile.myAdverts')}
      </Link>
    </div>
  );
}
